var moduleMap = {
	"./student/AddStudentQueryButton": () => {
		return Promise.all([__webpack_require__.e(287), __webpack_require__.e(47), __webpack_require__.e(719), __webpack_require__.e(422), __webpack_require__.e(428), __webpack_require__.e(427), __webpack_require__.e(423), __webpack_require__.e(132), __webpack_require__.e(558)]).then(() => (() => ((__webpack_require__(14558)))));
	},
	"./teacher/StudentMessagesDashboard": () => {
		return Promise.all([__webpack_require__.e(287), __webpack_require__.e(47), __webpack_require__.e(719), __webpack_require__.e(354), __webpack_require__.e(422), __webpack_require__.e(428), __webpack_require__.e(427), __webpack_require__.e(301), __webpack_require__.e(423), __webpack_require__.e(250), __webpack_require__.e(200), __webpack_require__.e(421), __webpack_require__.e(229), __webpack_require__.e(593)]).then(() => (() => ((__webpack_require__(48593)))));
	},
	"./student/MyInboxButton": () => {
		return Promise.all([__webpack_require__.e(422), __webpack_require__.e(626)]).then(() => (() => ((__webpack_require__(28626)))));
	},
	"./student/NewMessagesCount": () => {
		return Promise.all([__webpack_require__.e(422), __webpack_require__.e(713)]).then(() => (() => ((__webpack_require__(89713)))));
	},
	"./student/MyInboxPage": () => {
		return Promise.all([__webpack_require__.e(287), __webpack_require__.e(47), __webpack_require__.e(719), __webpack_require__.e(354), __webpack_require__.e(422), __webpack_require__.e(428), __webpack_require__.e(427), __webpack_require__.e(301), __webpack_require__.e(423), __webpack_require__.e(250), __webpack_require__.e(229), __webpack_require__.e(453), __webpack_require__.e(132), __webpack_require__.e(978)]).then(() => (() => ((__webpack_require__(78978)))));
	},
	"./teacher/AnnouncementsPage": () => {
		return Promise.all([__webpack_require__.e(287), __webpack_require__.e(47), __webpack_require__.e(852), __webpack_require__.e(719), __webpack_require__.e(77), __webpack_require__.e(446), __webpack_require__.e(422), __webpack_require__.e(428), __webpack_require__.e(427), __webpack_require__.e(94), __webpack_require__.e(301), __webpack_require__.e(200), __webpack_require__.e(222), __webpack_require__.e(833)]).then(() => (() => ((__webpack_require__(42460)))));
	},
	"./teacher/MessagingCenter": () => {
		return Promise.all([__webpack_require__.e(287), __webpack_require__.e(47), __webpack_require__.e(852), __webpack_require__.e(719), __webpack_require__.e(77), __webpack_require__.e(354), __webpack_require__.e(446), __webpack_require__.e(422), __webpack_require__.e(428), __webpack_require__.e(427), __webpack_require__.e(94), __webpack_require__.e(301), __webpack_require__.e(423), __webpack_require__.e(250), __webpack_require__.e(200), __webpack_require__.e(222), __webpack_require__.e(421), __webpack_require__.e(453), __webpack_require__.e(370)]).then(() => (() => ((__webpack_require__(74659)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});